module.exports = __webpack_public_path__ + "img/profile_box_playstyle.eeabafc8.svg";